<template>
  <dashboard>
    <template v-slot:content>
      <loading v-show="!loading" />
      <section>
        <b-container fluid>
          <div class="header-elements align-items-center">
            <b-row class="mt-2">
              <b-col lg="12" md="12">
                <b-row class>
                  <b-col lg="10" md="10">
                    <h5 class="mt-2" v-text="title"></h5>
                  </b-col>
                  <b-col lg="2" md="2">
                    <b-button block @click="back" id="back" variant="primary"
                      >Back</b-button
                    >
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </section>

      <section class="mt-2 checkout">
        <b-container fluid>
          <b-row>
            <b-col lg="4" md="4">
              <div class="table-dark-bg box-shadow p-3 pb-0 invoice-dtl">
                <div style="height:calc(100vh - 162px)">
                  <h6 class="fw-normal pb-1">Plan Information</h6>
                  <hr class="my-2" />
                  <b-row class>
                    <b-col md="12">
                      <label>Plan Name</label>
                      <p v-text="state.stock.plan_details.name"></p>
                    </b-col>
                  </b-row>
                  <b-row class>
                    <b-col md="12">
                      <label>Plan Description</label>
                      <p v-text="state.stock.plan_details.description"></p>
                    </b-col>
                  </b-row>
                  <b-row class>
                    <b-col md="6">
                      <label>Activated on</label>
                      <p v-text="state.stock.plan_details.activated_on"></p>
                    </b-col>
                    <b-col md="6">
                      <label>Due before</label>
                      <p v-text="state.stock.plan_details.due_on"></p>
                    </b-col>
                  </b-row>
                  <b-row class>
                    <b-col md="12">
                      <label>Department</label>
                      <div class="d-flex">
                        <p
                          v-text="state.stock.plan_details.department_list[0]"
                        />
                        &nbsp;&nbsp;
                        <span
                          v-show="state.stock.plan_details.department_list
                              .length > 1"
                          class="text-primary cursor-p"
                          @click="
                            showBrandList('Departments'),
                              (showMoreData.data =
                                state.stock.plan_details.department_list)
                          "
                          v-text="
                            `+${state.stock.plan_details.department_list
                              .length - 1} more`
                          "
                        />
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class>
                    <b-col md="12">
                      <label>Brands</label>
                      <div class="d-flex">
                        <p v-text="state.stock.plan_details.brand_list[0]" />
                        &nbsp;&nbsp;
                        <span
                        v-show="state.stock.plan_details.brand_list.length > 1"
                          class="text-primary cursor-p"
                          @click="
                            showBrandList('Brands'),
                              (showMoreData.data =
                                state.stock.plan_details.brand_list)
                          "
                          v-text="
                            `+${state.stock.plan_details.brand_list.length -
                              1} more`
                          "
                        />
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="mb-1">
                    <b-col md="12">
                      <label>Categories</label>
                      <div class="d-flex">
                        <p v-text="state.stock.plan_details.category_list[0]" />
                        &nbsp;&nbsp;
                        <span
                        v-show="state.stock.plan_details.category_list.length > 1"
                          class="text-primary cursor-p"
                          @click="
                            showBrandList('Categories'),
                              (showMoreData.data =
                                state.stock.plan_details.category_list)
                          "
                          v-text="
                            `+${state.stock.plan_details.category_list.length -
                              1} more`
                          "
                        />
                      </div>
                    </b-col>
                    <b-modal
                      id="show-more-modal"
                      ref="show-more-modal"
                      centered
                      hide-footer
                      :title="showMoreData.title"
                    >
                      <div class="show-more-modal">
                        <b-badge
                          v-for="(item, index) in showMoreData.data"
                          :key="index"
                          variant="primary"
                          v-text="item"
                          class="m-1"
                          style="font-size: 14px; font-weight: normal;"
                        />
                      </div>
                    </b-modal>
                  </b-row>
                </div>
                <b-row class="mt-3 mb-2">
                  <b-col lg="12">
                    <div class="action-btns d-flex">
                      <b-button
                        variant="primary"
                        block
                        class="mr-1"
                        :disabled="stockAuditItems.length == 0"
                        @click="freezeAudit"
                        id="freeze-audit"
                        >Freeze Audit</b-button
                      >

                      <b-button
                        variant="primary"
                        block
                        class="mr-1"
                        @click="stockPointCount"
                        id="add-new-count"
                        >Add New Count</b-button
                      >
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col lg="8" md="8" class="pl-0">
              <div class="table-dark-bg box-shadow px-0 py-3 sale">
                <div style="height:calc(100vh - 98px)" class="sale-summary">
                  <p class="pl-3">
                    Completed counts
                    <span
                      class="text-muted"
                      v-text="'(' + stockAuditItems.length + ')'"
                      >(0)</span
                    >
                  </p>
                  <div>
                    <b-table
                      striped
                      :fields="fields"
                      :items="stockAuditItems"
                      class="table cart-table table-dark px-5"
                      style="line-height: 16px;"
                    >
                      <template v-slot:cell(id)="data">{{
                        data.index + 1
                      }}</template>
                      <template v-slot:cell(stockpoint)="data">{{
                        data.item.stockpoint.name
                      }}</template>
                      <template v-slot:cell(edit)="data">
                        <font-awesome-icon
                          :icon="['fas', 'pencil-alt']"
                          style="cursor: pointer;"
                          @click="editCount(data.item)"
                        />
                      </template>
                    </b-table>
                    <p
                      v-if="stockAuditItems.length == 0 && !$loading"
                      style="height: 70vh;"
                      class="text-muted d-flex align-items-center justify-content-center"
                    >
                      No counts completed yet. Tap on ‘Add New Count’ to start a
                      new count.
                    </p>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </section>
    </template>
  </dashboard>
</template>

<script>
import Dashboard from "../views/Dashboard";
import Loading from "../components/Loading";
import axios from "axios";
import { mapState } from "vuex";
import db from "../database";
export default {
  name: "stock-count-audit",
  components: {
    Loading,
    Dashboard,
  },
  created() {
    // if (this.state.stock.plan_details.status == "F") {
    this.fetchStockWiseList();
    // }
  },
  mounted() {
    this.$store.commit("stock/clearGroupId");
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    vendorDetails() {
      return this.$store.getters["sessions/getVendorDetails"];
    },
  },
  data() {
    return {
      title: "Stock Audit Count",
      loading: true,
      showMoreData: {
        title: "",
        data: [],
      },
      stockAuditItems: [
        // {
        // id: 1,
        // stockpoint: "STORE_BACK_OFFICE",
        // description: "Description of the count",
        // products: 10,
        // total: 200,
        // completed_on: "31 Jan 2020 10:00"
        // }
      ],
      fields: [
        {
          key: "id",
          label: "#",
          class: "w-2 pl-3",
        },
        {
          key: "stockpoint",
          label: "Stockpoint",
          class: "w-20",
        },
        {
          key: "description",
          label: "Count description",
          class: "w-30",
        },
        {
          key: "unique_products",
          label: "Products",
          class: "w-10",
        },

        {
          key: "total_product_qty",
          label: "Total qty.",
          class: "w-10",
        },

        {
          key: "completed_on",
          label: "Completed on",
          class: "w-30",
        },
        {
          key: "edit",
          label: "",
        },
      ],
    };
  },

  methods: {
    back() {
      this.$router.push("/stock-audit");
    },
    freezeAudit() {
      this.$loading = true;
      let postData = {
        audit_plan_id: this.state.stock.plan_details.audit_plan_id,
        url: "/audit/complete-audit",
        audit_allocation_code: this.state.stock.plan_details
          .audit_plan_allocation_code,
      };

      let data = Object.assign(postData, this.vendorDetails);
      axios
        .post(data.url, data)
        .then(() => {
          this.$loading = false;
          this.$router.push("/stock-audit");
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    editCount(data) {
      this.$store.commit("stock/getGroupId", data.stock_point_id);
      db.stock.clear();
      this.stockPointCount();
    },
    fetchStockWiseList() {
      this.$loading = true;
      let postData = {
        url: "/audit/stockpoint-wise-list",
        audit_plan_id: this.state.stock.plan_details.audit_plan_id,
      };
      let data = Object.assign(postData, this.vendorDetails);
      axios
        .post(data.url, data)
        .then((response) => {
          this.stockAuditItems = response.data.data;
          this.$loading = false;
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    stockPointCount() {
      if (this.state.stock.plan_details.is_reconciliation == 0) {
        return this.$router.push("/stock-count");
      }
      this.$loading = true;
      let postData = {
        url: "/audit/reconsile-checker",
        audit_plan_id: this.state.stock.plan_details.audit_plan_id,
        is_reconciliation: this.state.stock.plan_details.is_reconciliation,
      };
      let data = Object.assign(postData, this.vendorDetails);
      axios
        .post(data.url, data)
        .then(() => {
          this.$router.push("/stock-count");
          this.$loading = false;
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    showBrandList(title) {
      this.$refs["show-more-modal"].show();
      this.showMoreData.title = title;
    },
  },
};
</script>
<style lang="scss" scoped>
.show-more-modal {
  max-height: 50vh;
  overflow: auto;
  @include custom-scrollbar();
}
</style>
